import React from 'react';
import AddressVerificationForm from '../common/addressVerificationForm';

const AddressVerificationDialog = ({
	title,
	enteredAddress,
	suggestedAddress,
	isEnteredAddressCorrect,
	onAddressSelection,
	disabledAddressTypes,
	errorMessage,
	messages,
	onClose,
	buttons
}) => {
	return (
		<div className={'overlayDialog visible'} id="addressVerificationOverlayDialog">
			<div className="blackoutLayer" onClick={onClose}></div>
			<div className="overlayDialogWindow">
				<a className="closeButton" onClick={onClose}>
					×
				</a>
				<div>
					<h2 className="title">{title}</h2>
				</div>
				<AddressVerificationForm
					enteredAddress={enteredAddress}
					suggestedAddress={suggestedAddress}
					isEnteredAddressCorrect={isEnteredAddressCorrect}
					onAddressSelection={onAddressSelection}
					disabledAddressTypes={disabledAddressTypes}
					noActions
				/>
				{(errorMessage || (messages && messages.length > 0)) && (
					<section className="text-center">
						{errorMessage && <p className="red">{errorMessage}</p>}
						{messages &&
							messages.map(message => (
								<p key={message} className="my-0">
									{message}
								</p>
							))}
					</section>
				)}
				<div className="actions">
					{buttons.map(button => (
						<button key={button.label} onClick={button.onClick} disabled={button.disabled}>
							{button.label}
						</button>
					))}
				</div>
			</div>
		</div>
	);
};

export default AddressVerificationDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/addressVerificationDialog.jsx